import React from "react";

import { CHAT_SUGGESTIONS } from "constants/chat.constants";

import { ExampleText } from "./styles";

import { Box, Collapse, Stack, Typography } from "@mui/material";

export const InfoTooltipContent = ({ handleSetExampleMessage, suggestions }) => {
  const items = suggestions || CHAT_SUGGESTIONS;

  return (
    <Box
      onMouseDown={(e) => e.preventDefault()}
      sx={{
        overflowY: "auto",
        height: "100%",
        maxHeight: "70vh",
        width: "750px",
        transition: "height 0.25s ease",
      }}
    >
      {CHAT_SUGGESTIONS.map((suggestion, index) => {
        const isVisible = items.some((item) => item.title === suggestion.title);
        const { title, commands, example } = suggestion;

        return (
          <Collapse in={isVisible} timeout={250} unmountOnExit key={index}>
            <Stack gap="5px" sx={{ whiteSpace: "pre-wrap" }} py="4px" px="6px">
              <Typography variant="subtitle2" fontWeight={600}>
                {title}:
              </Typography>
              {!!example && (
                <Typography variant="subtitle2" ml="30px">
                  (e.g., {example})
                </Typography>
              )}
              {commands.map((cmd, cmdIndex) => (
                <ExampleText key={cmdIndex} variant="subtitle2" onClick={() => handleSetExampleMessage(cmd)}>
                  {cmd}
                </ExampleText>
              ))}
            </Stack>
          </Collapse>
        );
      })}
    </Box>
  );
};
